import React, { useState, useEffect, Fragment } from 'react';
import { AxiosRequestConfig } from 'axios';
import { connect } from 'react-redux';
import { onStartDownloadImage } from '../../appRedux/actions';
import { Avatar } from 'antd';
import { IFetchtImage } from '../../interfaces';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { useQuery } from 'react-query';

function FetchtImage(props: IFetchtImage) {
  const [objectUrl, setObjectUrl] = useState<null | string>('');

  const { data } = useQuery(props.src, () => {
    return getImageData(props.src);
  });

  async function getImageData(url: string) {
    const http = await FaraGostarDynamicHttp();

    try {
      const config: AxiosRequestConfig = {
        responseType: 'blob',
      };

      const result = await http.get(url, config);
      return result.data;
    } catch (err) {
      return null;
    }
  }

  useEffect(() => {
    if (data) {
      if (props.setImageData) {
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = function () {
          const base64String = reader.result;

          if (props.setImageData) return props.setImageData(base64String);
        };
      }

      const objUrl = URL.createObjectURL(data);

      setObjectUrl(objUrl);
    }
  }, [data]);

  useEffect(() => {
    return () => {
      if (objectUrl) return URL.revokeObjectURL(objectUrl);
    };
  }, [objectUrl]);

  return (
    <div
      className={`gx-d-flex gx-flex-row gx-justify-content-center gx-align-items-center ${props.parentClassName}`}
    >
      <div className="gx-w-20">
        {objectUrl ? (
          <img
            alt={props.alt ? props.alt : 'fetch-image'}
            className={props.className}
            src={objectUrl}
          />
        ) : (
          <Fragment>
            {props.defaultImage ? (
              <img
                alt={props.alt ? props.alt : 'fetch-image'}
                className={props.className}
                src={props.defaultImage}
              />
            ) : (
              <div className={`gx-modal-box-avatar gx-mx-2 ${props.className}`}>
                <Avatar
                  size="large"
                  src={require('../../assets/images/placeholder.jpg')}
                />
              </div>
            )}
          </Fragment>
        )}
      </div>
      <div className="gx-w-80">
        {props.text ? (
          <span>
            {' '}
            {props.text} <br />
          </span>
        ) : (
          <span></span>
        )}
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: any) => ({
  onStartDownloadImage: (imageSrc: string) =>
    dispatch(onStartDownloadImage(imageSrc)),
});

export default connect(null, mapDispatchToProps)(FetchtImage);
